var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"az-footer"},[_c('div',{staticClass:"container-fluid"},[_c('span',[_vm._v(_vm._s(_vm.appSettings.copy_right_info || `© ${_vm.year} BluSalt`))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }